



















































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ArtMailInfo } from '@/models/enrolls/artMailInfo'
import BirthYearMonthPicker from '@/components/exam/BirthYearMonthPicker.vue'
import SexSelect from '@/components/exam/SexSelect.vue'
import EnrollTextarea from '@/components/exam/EnrollTextarea.vue'
import PhotoUploader from '@/components/exam/PhotoUploader.vue'
import { uploadMailInflFile } from '@/apis/enroll/artMailInfo'
import { getKey } from '@/utils/key'

@Component({
  components: {
    BirthYearMonthPicker,
    SexSelect,
    PhotoUploader,
    EnrollTextarea
  }
})
export default class ArtMailForm extends Vue {
  @Prop({ required: true }) value!: ArtMailInfo
  @Prop({ default: false }) print!: boolean
  @Prop({ default: '' }) title!: string
  getKey = getKey

  get form() {
    return this.value
  }

  set form(value: ArtMailInfo) {
    this.$emit('update:value', value)
  }

  uploadPicture = uploadMailInflFile

  get picture() {
    return this.form.mailPicAdd
  }

  set picture(value: string) {
    const baseURL = process.env.VUE_APP_BASE_API
    this.form.mailPicAdd = `${baseURL}/student/ArtMailInfo/files/${value}`
  }
}
